import React from 'react'
import { useMedia } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import { WidthContainer } from 'components/_new/layout/widthContainer'
import Countdown from 'components/ui/countdown/ActiveQueueCountdown/ActiveQueueCountdown'

import s from './TimerSection.scss'


const TimerSection = ({ messages }) => {
  const { isMobile } = useMedia()

  return (
    <Box mt="36" pb="36">
      <WidthContainer className={s.content}>
        <Box className={s.container} p={!isMobile && '60'} center>
          <Box className={s.textContainer} pr={!isMobile && '36'}>
            <Text size={isMobile ? '18-24' : '28-40'} message={messages.title} semibold />
            <Text message={messages.description} size="16-24" html />
          </Box>
          <Box mt="24">
            <Countdown className={s.countdown} withDecor />
          </Box>
        </Box>
      </WidthContainer>
    </Box>
  )
}


export default TimerSection
